
























import { Component, Vue, Prop } from 'vue-property-decorator';

import AdminService from '@/api/AdminService';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';

@Component({})
export default class CoinStoreTransferHistory extends Vue {
  @Prop(String) businessId!: string;

  adminService: AdminService = new AdminService();

  activities: Record<string, any>[] = [];
  loading: boolean = true;
  next: string = '';

  async getActivities() {
    this.loading = true;
    try {
      const { data } = await this.adminService.getTwismSendCoinsStoreHistory(
        this.businessId,
        this.next
      );

      const prepareData = data.map((activity: any) => ({
        ...activity,
        time: DateUtils.formatISOLongDate(activity.createdAt, true)
      }));

      this.activities = prepareData;
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await this.getActivities();

    eventBus.$on('reloadCoinStoreHistory', this.getActivities);
  }

  beforeDestroy() {
    eventBus.$off('reloadCoinStoreHistory', this.getActivities);
  }
}
